import React from 'react'

const VendorProfile = () => {
  return (
    <div>VendorProfile</div>
  )
}

export default VendorProfile